export default {
    SupportUserId: "ceb6b917-350d-4bec-a696-ea011d717542",
    IsSupportUserId: (id: string) => {
        return id.toLowerCase();
    }
}